import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import {getAuthInfo} from '../utils/auth';
import {getQueryString} from '../utils/helper';

Vue.use(Vuex);

const jwt = getAuthInfo() || {};

const state = {
  topbarVisible: getQueryString('hidetopbar') !== '1',
  sidebarVisible: getQueryString('hideleftbar') !== '1',
  token: jwt.access_token,
  user: {
    name: jwt.preferred_username || '用户名',
    sp_id: jwt.sp_id,
    sp_name: jwt.sp_name || '服务商名称',
    avatar: jwt.avatar,
    sp_contactor: jwt.sp_contactor
  },
  invite: {
    loading: true,
    qrcode: null,
    reportqrcodes: [],
    url: null,
    reporturls: '',
    home_page_url: '',
    is_apply_sub_domain: false,
    sub_domain_name: '',
    sub_domain_status: 0,
    is_apply_own_domain: false,
    own_domain_name: '',
    own_domain_status: 0
  },
  info: {
    saving: false,
    loading: false,
    name: '',
    contactor: '',
    contact_phone: '',
    email: '',
    address: '',
    about_content: '',
    sub_domain: '',
    yhl_team_name: '',
    yhl_team_id: '',
    yhl_branch_id: null,
    active_edition: '试用版',
    expire_date: null,
    logo: null,
    spec: 0,
    left_days: 0,
    login_account: '',
    use_we_chat_third_party_platform: true,
    bind_sys_code: null
  },
  wechat: {
    saving: false,
    loading: false,
    app_id: '',
    app_secret: '',
    encoding_aes_key: '',
    token: '',
    server_ip: '',
    callback_url: '',
    verified_domain: '',
    is_empty: true,
    qr_code: '',
    is_template_message_enabled: false,
    transfer_message_to_kf_system: false,
    ticket_progress_changed_template_id: null
  },
  wechat_menu: {
    saving: false,
    loading: false,
    menu: {}
  },
  form: {
    df_loading: false,
    df: {},
    loading: false,
    saving: false,
    list: [],
    total: 0,
    shared_list: [],
    shared_total: 0
  },
  report_list: {
    loading: false,
    columns: [],
    data: [],
    additional_parameters: {},
    total: 0
  },
  report_detail: {
    loading: false,
    ticket: null,
    no: '',
    videos: [],
    voices: [],
    attachments: [],
    service_ticket: null,
    service_ticket_loaded: false,
  },
  report_steps: {
    querying: false,
    steps: [],
    current: 0
  },
  sub_domain_list: {
    loading: false,
    data: [],
    total: 0
  },
  account_info: {
    loading: false,
    list_loading: false,
    spec: 0,
    can_renew_service: false,
    can_upgrade_edition: false,
    active_edition: '试用版',
    expire_date: null,
    left_days: 0,
    list_data: [],
    list_total: 0
  },
  sp_list: {
    loading: false,
    data: [],
    total: 0
  },
  setting: {
    loading: false,
    saving: false,
    setting: null
  },
  repair_member_list: {
    loading: false,
    data: [],
    total: 0
  },
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});



// WEBPACK FOOTER //
// ./src/store/index.js